export enum ENUM__graph_template_name {
  CUSTOM = 'Custom',
  /*
   * EDIT
   */
  OUTPUT_ASPECT_RATIO = 'Output Aspect Ratio',
  REMOVE_BACKGROUND = 'Remove Background',
  UPSCALE_IMAGE = 'Upscale',
  UPSCALE_IMAGE_TO_SIDE = 'Upscale To Side',
  UPSCALE_IMAGE_WITH_DENOISE = 'Upscale with Denoise',
  TRIM_COLOR = 'Trim Color',

  REMOVE_OBJECT_LAMA = 'Remove Object: LaMa',

  CREATE_COLOR_MAP = 'Create Color Map',

  CREATE_LINES_CANNY = 'Create Lines Canny',
  CREATE_LINES_CANNY_SEMI_AUTO = 'Create Lines Canny Semi Auto',
  CREATE_LINES_CANNY_AUTO = 'Create Lines Canny Auto',

  CREATE_LINES_HED = 'Create Lines Soft Edge HED',

  CREATE_DEPTH = 'Create Depth',

  /*
   *
   */
  IMAGE_MASK__CREATE_GRADIENT = 'Create Gradient',

  /*
   * GENERATE
   */
  GENERATE_SD_1 = 'Generate with SD 1',
  SD_1__OUTPAINT = 'SD 1: Outpaint',
  SD_1__MIXTURE_OF_DIFFUSERS = 'SD 1: Mixture of Diffusers',
  SD_1__MULTI_DIFFUSION = 'SD 1: Multi Diffusion',

  APPLY_COLOR = 'Apply Color',
  TUNE_DESCRIPTION = 'Tune Description',
  TUNE_GENERATION_LEVEL = 'Tune Generation Level',
  TUNE_DEPTH = 'Tune Depth',
  TUNE_LINES = 'Tune Lines',
  REFERENCE_IMAGE_ONE = 'Reference Image 1',
  REFERENCE_IMAGE_TWO = 'Reference Image 2',
  TWO_REFERENCES = 'Two References',
  SELECT_MODELS = 'Select Models',
  SELECT_VAE = 'Select VAE',
  SELECT_LORAS = "Select LoRa's",
}
